import { useEffect, useMemo, useState } from 'react';

import { Space } from 'antd';

import useNotification from '@/hooks/notifications';

import SortableTable from '@Components//Tables/SortableTable';

import { postData } from '@/utils/api';
import useFetchListData from '@/hooks/useFetchListData';
import { useSelector } from 'react-redux';
import authSelector from '@Redux/auth/authSelector';
import { highlightItemPost } from '@/utils/fetchFunctions/highlight';

export default function OrderFeaturedTopics() {
	const { openNotification } = useNotification();
	const { jwttoken } = useSelector(authSelector);
	const [loadingChange, setLoadingChange] = useState(false);

	const params = useMemo(() => {
		return {url: 'topics', featured: true};
	}, []);

	const {data, loading, error, getData} = useFetchListData({params, useDefaultParams: true});

	const sortedData = useMemo(() => data ? [...data]?.sort((a, b) => b?.position - a?.position) : [], [data]);

	useEffect(() => {
		if (error) {
			showError(error);
		}
	}, [error]);

	function showError (error) {
		openNotification({message: 'Something went wrong!', description: error.message || null, type: 'error'});
	}

	const saveItems = async (items) => {
		const topicKeys = items
			.sort((a, b) => a.position - b.position)
			.reduce((acc, {id}) => acc + id + ';', '');

		const {error, message} = await postData({endpoint: `/topics/featured-order?topicKeys=${topicKeys}`, noResponse: true, auth: jwttoken});

		if (error) {
			showError(message);
		}

		await getData();

		setLoadingChange(false);
	};

	async function select (id) {
		setLoadingChange(true);

		const res = await highlightItemPost({url: 'topics', id, name: 'featured'});

		if (res.error) {
			openNotification({message: 'Something went wrong!', description: res.message || null, type: 'error'});
			setLoadingChange(false);
			return;
		}

		await getData();
		setLoadingChange(false);
	}

	async function unselect (id) {
		setLoadingChange(true);
		const res = await highlightItemPost({url: 'topics', id, name: 'featured', highlighted: false});

		if (res.error) {
			openNotification({message: 'Something went wrong!', description: res.message || null, type: 'error'});
			setLoadingChange(false);
			return;
		}

		await getData();
		setLoadingChange(false);
	}

	return (
		<Space size="large" direction='vertical' style={{width: '100%'}} >
			<SortableTable
				data= {sortedData}
				loading={loading || loadingChange}
				saveItems={saveItems}
				idKey='key'
				name='topics'
				updateDate
				select={select}
				unselect={unselect}
			/>
		</Space>
	);
}